import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getDashBoardShopSuccess,
  getDashBoardShopFailed,
  GET_DASHBOARD_SHOP_START,
} from '../../actions/dashboard'

/**
 * get dashBoard mkp api
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getDashBoardShopApi = (props) => {
  var uri = `/admin/dashboard/shop`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetDashBoardShop(action) {
  try {
    const response = yield call(getDashBoardShopApi, action?.payload)
    if (response?.statusCode !== 400) {
      yield put(getDashBoardShopSuccess(response))

      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess(response)
      }
    } else {
      throw response?.message
    }
  } catch (error) {
    yield put(getDashBoardShopFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get dashBoard mkp
 */
export default function* watchGetDashBoardShop() {
  yield takeLatest(GET_DASHBOARD_SHOP_START, doGetDashBoardShop)
}
